import React from 'react';

interface MessageProps {
  message?: string;
}

const Message: React.FC<MessageProps> = ({ message }) => {
  return (
    <>
      {message}
    </>
  );
};

export default Message;
